import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Meta from "../commons/Meta/Meta";
import axios from "axios";

// Language redirector with geo-IP detection and localStorage preference
const LanguageRedirector = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const key = location.pathname.length > 1 ? location.pathname.replace(/\/$/, '') : location.pathname;
    const metaEntry = Meta[key];
    if (!metaEntry) return;

    const currentLang = metaEntry.lang === "fr_CA" ? "fr" : "en";
    const isFrenchPage = metaEntry.lang === "fr_CA";

    try {
      const storedLangRaw = localStorage.getItem("preferredLanguage");
      if (storedLangRaw) {
        const storedLang = JSON.parse(storedLangRaw);
        if (storedLang.value === currentLang) return;
        const redirectPath = metaEntry[storedLang.value]?.replace("https://www.travelance.ca", "");
        if (redirectPath) {
          navigate(redirectPath);
        }
        return;
      }
    } catch (e) {
      console.error("Failed to parse stored language:", e);
    }

    axios.get("https://ipapi.co/json/").then(({ data }) => {
      const isInQuebec = data?.region_code === "QC" || data?.region === "Quebec";
      if (isInQuebec && !isFrenchPage) {
        localStorage.setItem("preferredLanguage", JSON.stringify({
          value: "fr",
          expiry: Date.now() + 7 * 24 * 60 * 60 * 1000 // 7 days
        }));

        const redirectPath = metaEntry["fr"]?.replace("https://www.travelance.ca", "");
        if (redirectPath) {
          navigate(redirectPath);
        }
      }
    }).catch((error) => {
      // Default to English if IP fetch fails
      localStorage.setItem("preferredLanguage", JSON.stringify({
        value: "en",
        expiry: Date.now() + 7 * 24 * 60 * 60 * 1000
      }));
      console.error("IP detection failed:", error.message);
    });
  }, [location, navigate]);

  return null;
};

export default LanguageRedirector;
